
import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface SidebarLinkProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  isActive?: boolean;
  isOpen: boolean;
}

const SidebarLink: React.FC<SidebarLinkProps> = ({ to, icon, label, isActive, isOpen }) => {
  return (
    <NavLink
      to={to}
      className={({ isActive: active }) =>
        cn(
          "flex items-center gap-3 rounded-lg px-3 py-2 text-gray-500 dark:text-gray-400 transition-all hover:text-gray-900 dark:hover:text-gray-100 group",
          (isActive || active) ? "bg-royalty-50 text-royalty-700 dark:bg-royalty-900/40 dark:text-royalty-300 font-medium" : "",
          "hover:bg-royalty-50/50 dark:hover:bg-royalty-900/20 transition-all duration-200"
        )
      }
    >
      <span className="group-hover:translate-x-0.5 transition-transform duration-200">{icon}</span>
      <span className={cn(
        "group-hover:translate-x-0.5 transition-transform duration-200",
        !isOpen && "lg:hidden"
      )}>{label}</span>
    </NavLink>
  );
};

export default SidebarLink;
